import React from 'react';
import Vehicles from './Vehicles';
import useVehiclesQuery from '../api/use-vehicles-query';
import ResultsSkeleton from '../components/skeletons/ResultsSkeleton';

const ResultsVehicles = () => {
  const { isLoading } = useVehiclesQuery();

  return isLoading ? <ResultsSkeleton /> : <Vehicles />;
};

export default ResultsVehicles;
